import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {SharedService} from './shared.service';
import {Observable, of} from 'rxjs';
import {catchError} from 'rxjs/operators';

@Injectable()
export class UserService{

  private jsonOptions = {
    headers: new HttpHeaders().set('Accept', 'application/json').set('Content-Type', 'application/json')
  };

  constructor(private http: HttpClient, private sharedService: SharedService) {
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      if (!error.error) {
        error.error= { message: 'Some error occurred, you may not have permission to access this action.'}
      }
      if (error.error && !error.error.message) {
        error.error= { message: 'Some error occurred, you may not have permission to access this action.'}
      }

      return of(error as T);
    };
  }

   public viewSingleUser(userId:any){
    return  this.http.get(this.sharedService.getFranchiseUrl() + 'session/single/user/'+userId, this.jsonOptions).pipe(
      catchError(this.handleError<any>('viewSingleUser', {})),
    );
  }

  updateCountry(userId: string, country: string): Observable<any> {
    return this.http.put(`${this.sharedService.getFranchiseUrl()}session/user/${userId}/country/${country}`,{});
  }

  updateUserDetails(selectedUserId: any, user:any) {
      return this.http.put(this.sharedService.getFranchiseUrl()+'session/update/user/info/'+selectedUserId,user,this.jsonOptions).pipe(
        catchError(this.handleError<any>('UpdateUserDetails', {})),
      );
    }

}
